import { Box, styled } from '@mui/material';

export const AdditionalSectionStyled = styled(Box)`
    text-align: left;
    padding: 0 25px;
    display: flex;
    justify-content: space-between;
`;
